// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-notes .name {\n  width: 15%;\n}\n.display-notes .date {\n  width: 15%;\n}\n.display-notes .note {\n  width: 70%;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
